import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { DialogService } from './dialog.service';
import { concatMap, filter, take } from 'rxjs';

@Injectable()
export class ApplicationUpdateService {
    constructor(private swUpdate: SwUpdate, private dialogService: DialogService) {}

    private get isSwEnabled(): boolean {
        return this.swUpdate.isEnabled;
    }

    updateDetection(): void {
        if (this.isSwEnabled) {
            this.swUpdate.versionUpdates
                .pipe(
                    filter(({ type }) => type === 'VERSION_READY'),
                    concatMap(() =>
                        this.dialogService.askQuestion(
                            'Системное сообщение',
                            'Доступна более новая версия. Обновить приложение до последней версии ?'
                        )
                    ),
                    take(1)
                )
                .subscribe({
                    next: (result) => {
                        if (result) {
                            self.location.reload();
                        }
                    },
                    error: (error) => {
                        this.dialogService.notifyInSnackBar(error, 'error');
                    },
                });
        } else {
            this.dialogService.notifyInSnackBar('ServiceWorker недоступен', 'error', { duration: 10_000 });
        }
    }
}
